import config from '../config'
import { authorizedFetch } from '../utils/auth.js'
import { checkStatus } from '../utils/fetch'
import { logOut } from '../actions/users'

export const SHOW_ADD_CLUSTERS_FORM = 'SHOW_ADD_CLUSTERS_FORM'
export const CLOSE_ADD_CLUSTERS_FORM = 'CLOSE_ADD_CLUSTERS_FORM'
export const UPDATE_CLUSTER_FIELD = 'UPDATE_CLUSTER_FIELD'
export const UPDATE_CLUSTER_SUCCEEDED = 'UPDATE_CLUSTER_SUCCEEDED'
export const RECEIVED_CLUSTERS = 'RECEIVED_CLUSTERS'
export const REQUEST_CLUSTERS = 'REQUEST_CLUSTERS'
export const ON_BUILDING_SELECT = 'ON_BUILDING_SELECT'
export const DELETE_CLUSTER_SUCCEEDED = 'DELETE_CLUSTER_SUCCEEDED'
export const SHOW_ADD_CLUSTER_FORM = 'SHOW_ADD_CLUSTER_FORM'

export const closeAddClusterForm = () => ({
  type: CLOSE_ADD_CLUSTERS_FORM
})

export const updateField = (name, value) => ({
  type: UPDATE_CLUSTER_FIELD,
  name: name,
  value: value
})

export const fetchClusters = () => (dispatch) => {
  dispatch(requestClusters())
  authorizedFetch(config.api_url + 'clusters/list')
    .then(checkStatus)
    .then((response) => response.json())
    .then((json) => dispatch(receivedClusters({ data: json })))
    .catch(function(error) {
      dispatch(logOut())
    })
}

export const receivedClusters = (json) => ({
  type: RECEIVED_CLUSTERS,
  json: json.data
})

export const requestClusters = () => ({
  type: REQUEST_CLUSTERS
})

export const updateCluster = (clusterName, clusterId, buildings) => (dispatch) => {
  var headers = new Headers()
  headers.append('Content-Type', 'application/json')
  headers.append('Access-Control-Allow-Origin', '*')
  headers.append('Accept', 'application/json')

  authorizedFetch(config.api_url + 'clusters/update', {
    headers: headers,
    mode: 'cors',
    cache: 'default',
    method: 'POST',
    body: JSON.stringify({ cluster: { name: clusterName, _id: clusterId, buildings: buildings } })
  })
    .then(checkStatus)
    .then((response) => response.json())
    .then((json) => dispatch(updateClusterSucceeded(json)))
    .catch(function(error) {
      dispatch(logOut())
    })
}

export const updateClusterSucceeded = (cluster, buildingsId) => ({
  type: UPDATE_CLUSTER_SUCCEEDED,
  cluster,
  buildingsId
})

export const deleteCluster = (cluster) => (dispatch) => {
  var headers = new Headers()
  headers.append('Content-Type', 'application/json')
  headers.append('Access-Control-Allow-Origin', '*')
  headers.append('Accept', 'application/json')

  authorizedFetch(config.api_url + 'clusters/delete', {
    headers: headers,
    mode: 'cors',
    cache: 'default',
    method: 'POST',
    body: JSON.stringify({ cluster })
  })
    .then(checkStatus)
    .then((response) => response.json())
    .then((json) => dispatch(deleteClusterSucceeded(json)))
    .catch(function(error) {
      dispatch(logOut())
    })
}

export const deleteClusterSucceeded = (cluster) => ({
  type: DELETE_CLUSTER_SUCCEEDED,
  cluster
})

export const onBuildingSelect = (buildingId) => ({
  type: ON_BUILDING_SELECT,
  buildingId
})

export const showUpdateClusterForm = (cluster) => ({
  type: SHOW_ADD_CLUSTER_FORM,
  cluster: cluster
})



// WEBPACK FOOTER //
// ./src/actions/clusters.js